import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'

import { ConfigOptions } from '../common/app-config'

class PageView extends React.Component<
  { config: ConfigOptions } & RouteComponentProps<{}>,
  {}
> {
  render() {
    const message = '404.Taka strona nie została znaleziona'
    return (
      <div>
        <h3>{message}</h3>
        <a href="/">Wróć do strony głównej</a>{' '}
      </div>
    )
  }
}
const mapStateToProps = state => ({
  config: state.ui.config,
})
export const PublicPage = connect(mapStateToProps)(PageView)

export default PublicPage
